<template>
  <div
    id="icon-pack-design-showcase"
    class="icon-design-showcase position-relative"
  >
    <svg
      :id="`icon-design-${iconPack().name}`"
      :class="['icon-design', { 'is-highlighting-grid': isHighlightingIconDesignGrid }, { 'is-highlighting-canvas': isHighlightingIconDesignCanvas }]"
      :viewBox="`0 0 ${iconPackSourceCanvasHeight} ${iconPackSourceCanvasHeight}`"
      :style="`
        --size: ${iconPack().sourceGridHeight};
        --padding: ${iconDesignPadding};
        --icon-design-specimen-primary-color: var(--theme-icon-design-path-color);
        --icon-design-specimen-secondary-color: var(--theme-icon-design-fill-color);
      `"
    >
      <rect class="reticle" />

      <svg :viewBox="`0 0 ${iconDesignSVGViewboxSize} ${iconDesignSVGViewboxSize}`">
        <path
          v-if="iconPack().iconDesignShowcase.secondaryPath"
          :d="iconPack().iconDesignShowcase.secondaryPath"
          clip-rule="evenodd"
          fill-rule="evenodd"
          style="fill: var(--icon-design-specimen-secondary-color, currentColor); opacity: var(--icon-design-specimen-secondary-opacity, 0.5)"
        />

        <path
          :d="iconPack().iconDesignShowcase.primaryPath"
          style="fill: var(--icon-design-specimen-primary-color, currentColor); opacity: var(--icon-design-specimen-primary-opacity, 1)"
        />
      </svg>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'PackIconDesignShowcase',

    inject: ['iconPack'],

    props: {
      isHighlightingIconDesignCanvas: {
        type: Boolean,
        default: false
      },
      isHighlightingIconDesignGrid: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        iconDesignSVGViewboxSize: 320
      }
    },

    computed: {
      iconDesignPadding() {
        return (this.iconPackSourceCanvasHeight - this.iconPack().sourceGridHeight) * 0.5
      },

      // TODO: get this value for realsies
      iconCount() {
        return 1000
      },

      iconPackSourceCanvasHeight() {
        return this.iconPack().sourceCanvasHeight
      },

      // TODO: get this value for realsies
      packLastUpdatedVersion() {
        return '7.0.0'
      }
    }
  }
</script>
